import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2438f35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = { class: "logo-link" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dashboard-name" }, " Dashboard ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.baseURL + 'static/entrupy_logo.png',
              class: "logo-img"
            }, null, 8, _hoisted_6),
            _hoisted_7
          ])
        ])
      ])
    ])
  ]))
}